// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"892":"9d8ddd51","7740":"a0a35a59"}[chunkId] + ".chunk.css";
};